var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconListLayout = function SvgIconListLayout(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.09 6.18V9.5h10V6.18zm0 11.64h10V14.5h-10zm0-4.14h10v-3.36h-10zM4.91 9.5h3.36V6.18H4.91zm0 8.32h3.36V14.5H4.91zm0-4.14h3.36v-3.36H4.91z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconListLayout);
export { ForwardRef as ReactComponent };